import { Link } from "react-router-dom";
import { ArrowUpRight, PlayCircle } from "lucide-react";
import { img } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export const StoryCard = ({ post, featured }) => {
  const { t, L, to, lang } = useLang();
  const href = to(`/stories/${post.slug}`);
  const date = post.published_at && new Date(post.published_at.length === 10 ? `${post.published_at}T12:00:00` : post.published_at).toLocaleDateString(lang === "es" ? "es-NI" : "en-US", { year: "numeric", month: "long", day: "numeric" });
  return (
    <article className="group flex h-full flex-col" data-testid={`story-card-${post.slug}`}>
      <Link to={href} className={`img-zoom relative block overflow-hidden rounded-2xl ${featured ? "aspect-[16/11]" : "aspect-[4/3]"}`} data-testid={`story-card-image-${post.slug}`}>
        <img src={img(post.cover_image)} alt={L(post, "title")} loading="lazy" className="h-full w-full object-cover" />
        {(post.video_url || post.video_file) && <PlayCircle className="absolute right-4 top-4 h-9 w-9 text-white drop-shadow-lg" />}
      </Link>
      <div className="flex flex-1 flex-col pt-5">
        {date && <p className="eyebrow">{date}</p>}
        <h3 className={`mt-2 font-display font-black leading-snug text-ink ${featured ? "text-2xl sm:text-3xl" : "text-xl"}`}>
          <Link to={href} className="hover:text-forest">{L(post, "title")}</Link>
        </h3>
        <p className="mt-3 line-clamp-3 text-sm font-medium leading-relaxed text-moss">{L(post, "excerpt")}</p>
        <Link to={href} className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-forest hover:underline" data-testid={`story-card-read-${post.slug}`}>
          {t("stories.read")} <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
      </div>
    </article>
  );
};
